
import Vue from "vue";

export default Vue.extend({
  name: "AIBotLoading",
  computed: {
    aiLoadingContext(): string | null {
      return this.$store.getters["ai_assessment/aiLoadingContext"] as
        | string
        | null;
    },
    loadingText(): string {
      switch (this.aiLoadingContext) {
        case "creating_session":
          return String(
            this.$t("ai-assessments.generated.loading.creating_session")
          );
        case "creating_assessment":
          return String(
            this.$t("ai-assessments.generated.loading.creating_assessment")
          );
        case "chat":
          return String(
            this.$t("ai-assessments.generated.loading.chat_processing")
          );
        default:
          return String(
            this.$t("ai-assessments.generated.loading.analyzing_requirement")
          );
      }
    }
  },
  data() {
    return {
      isLoading: true,
      topSparkleVisible: false,
      bottomSparkleVisible: false,
      centralStarVisible: false,
      topSparkleSize: 20,
      bottomSparkleSize: 20,
      centralStarSize: 20,

      sparkleInterval: null as ReturnType<typeof setInterval> | null
    };
  },
  mounted() {
    // Start sparkle animation
    this.startSparkleAnimation();

    // Auto-hide loading after 5 seconds
    setTimeout(() => {
      this.isLoading = false;
      this.$emit("loading-complete");
    }, 5000);
  },

  methods: {
    startSparkleAnimation() {
      this.sparkleInterval = setInterval(() => {
        // Randomly show/hide top sparkle
        if (Math.random() > 0.5) {
          this.topSparkleVisible = !this.topSparkleVisible;
          // Change size when appearing
          if (this.topSparkleVisible) {
            this.topSparkleSize = Math.floor(Math.random() * 15) + 15; // Random size between 15-30
            // Set random scale between 1-3
            const randomScale = Math.random() * 2; // 1.0 to 3.0
            document
              .querySelector(".ai-bot-loading")
              ?.setAttribute("style", `--top-sparkle-scale: ${randomScale}`);
          }
        }

        // Randomly show/hide bottom sparkle
        if (Math.random() > 0.5) {
          this.bottomSparkleVisible = !this.bottomSparkleVisible;
          // Change size when appearing
          if (this.bottomSparkleVisible) {
            this.bottomSparkleSize = Math.floor(Math.random() * 15) + 15; // Random size between 15-30
            // Set random scale between 1-3
            const randomScale = Math.random() * 2; // 1.0 to 3.0

            document
              .querySelector(".ai-bot-loading")
              ?.setAttribute("style", `--bottom-sparkle-scale: ${randomScale}`);
          }
        }

        // Randomly show/hide central star
        if (Math.random() > 0.5) {
          this.centralStarVisible = !this.centralStarVisible;
          // Change size when appearing
          if (this.centralStarVisible) {
            this.centralStarSize = Math.floor(Math.random() * 20) + 40; // Random size between 40-60
            // Set random scale between 1-3
            const randomScale = Math.random() * 2; // 1.0 to 3.0
            document
              .querySelector(".ai-bot-loading")
              ?.setAttribute("style", `--central-star-scale: ${randomScale}`);
          }
        }
      }, 200); // Change every 200ms - much faster!
    },

    stopSparkleAnimation() {
      if (this.sparkleInterval) {
        clearInterval(this.sparkleInterval);
        this.sparkleInterval = null;
      }
    }
  }
});
